import { Card, Container } from '@mui/material';
import Page from '../components/Page';
import { ProfileNurseryForm } from '../components/_dashboard/user';

export default function UpdateNursery() {
  return (
    <Page title="Educatrice">
      <Container>
        <Card>
          <ProfileNurseryForm />
        </Card>
      </Container>
    </Page>
  );
}
